import Layout from "../components/Layout";
import {ProgressSpinner} from "primereact/progressspinner";
import React, {useEffect, useRef, useState} from "react";
import axios from "axios";
import {BASE_URL} from "../utils/commonUrl";
import {useSelector} from "react-redux";
import {Toast} from "primereact/toast";
import CompOpinionCard from "../components/CompOpinionCard";
import EmpInfoCard from "../components/EmpInfoCard";
import './SupervisorAssessmentPage.css'
import {toast} from 'react-toastify'

const SupervisorCompOpinion = () => {
    const primeToast = useRef(null)
    const {user} = useSelector(state => state['auth']);
    const [optionList, setOptionList] = useState([]);
    const [employees, setEmployees] = useState({isLoading: false, list: []})
    const [employeeAssessment, setEmployeeAssessment] = useState({isLoading: false, list: []})
    const [supervisorAssessment, setSupervisorAssessment] = useState([]);
    const [supervisorUpdateCount, setSupervisorUpdateCount] = useState([])
    const [selectedEmployeeId, setSelectedEmployeeId] = useState(-1)
    const successNotify = (message) => toast.info(message);
    const errorNotify = (message) => toast.error(message);

    useEffect(function () {
        getEmployeeList();
        getOpinionList();
    }, [])

    const getOpinionList = () => {
        ///api/competencyOpinion/GetActiveList

        axios.get(BASE_URL + "/api/competencyOpinion/GetActiveList")
            .then(response => {
                setOptionList(response.data)
            }).catch(e => {

        })
    }

    const getEmployeeList = () => {
        setEmployees({isLoading: true, list: []})
        const registerId = user.registerID;
        axios.get(BASE_URL + "/api/competencyinformation/CompetencyUserForSupervised/" + registerId)
            .then(response => {
                setEmployees({isLoading: false, list: []})
                if (response.status === 200) {
                    setEmployees({isLoading: false, list: response.data})
                }
            }).catch(e => {
            setEmployees({isLoading: false, list: []})
            console.log(e)
        })

    }


    const onEmployeeSelect = (e) => {
        const registerId = parseInt(e.currentTarget.value)
        setSelectedEmployeeId(registerId)
        if (registerId > 0) {
            getEmployeeAssessment(registerId)
            SupervisorUpdateCount(registerId)
        } else {
            setEmployeeAssessment({...employeeAssessment, list: []})
        }
    }
    const getEmployeeAssessment = (id) => {
        setEmployeeAssessment({isLoading: true, list: []})
        axios.get(BASE_URL + "/api/competencyinformation/CompetencyUserDetailsForSupervised/" + id)
            .then(response => {
                setEmployeeAssessment({isLoading: false, list: response.data})
            })
            .catch(e => {
                setEmployeeAssessment({isLoading: false, list: []})
                console.log(e)
            })
    }

    const SupervisorUpdateCount = (id) => {
        axios.get(BASE_URL + "/api/competencyinformation/CompetencySupervisorStatusCount/" + id)
            .then(response => {
                setSupervisorUpdateCount(response.data)
            }).catch(e => {

        })
    }

    const onSupervisorOpinionChange = (weight, assessmentItem) => {
        console.log("onSupervisorOpinionChange=======>", weight, assessmentItem)
        if (parseInt(weight) === -1) {
            const restResult = supervisorAssessment.filter(item => item.competencyInformationID !== assessmentItem.competencyInformationID);
            setSupervisorAssessment(restResult)
            return
        }
        if (supervisorAssessment.length === 0) {
            setSupervisorAssessment([...supervisorAssessment,
                {
                    supervisorCompetencyOpinionID: weight,
                    competencyInformationID: assessmentItem.competencyInformationID,
                    registerID: user.registerID
                }])
        } else {
            const existResult = supervisorAssessment.filter(item => item.competencyInformationID === assessmentItem.competencyInformationID);
            if (existResult.length === 0) {
                setSupervisorAssessment([...supervisorAssessment,
                    {
                        supervisorCompetencyOpinionID: weight,
                        competencyInformationID: assessmentItem.competencyInformationID,
                        registerID: user.registerID
                    }])
            } else {
                const filterResult = supervisorAssessment.filter(item => item.competencyInformationID !== assessmentItem.competencyInformationID);
                filterResult.push({
                    supervisorCompetencyOpinionID: weight,
                    competencyInformationID: assessmentItem.competencyInformationID,
                    registerID: user.registerID
                })
                setSupervisorAssessment(filterResult)
            }
        }


    }

    const saveAssessment = () => {
        console.log("saveAssessment ")
        const copySupervisorAssessment = [...supervisorAssessment]
        if (supervisorAssessment.length === 0){
            employeeAssessment.list.map(assessmentItem=>{
                copySupervisorAssessment.push({
                    supervisorCompetencyOpinionID: assessmentItem.supervisorCompetencyOpinionID || assessmentItem.userCompetencyOpinionID,
                    competencyInformationID: assessmentItem.competencyInformationID,
                    registerID: user.registerID
                });
            })
        }
        else if (supervisorAssessment.length < employeeAssessment.list.length){
            employeeAssessment.list.map(assessmentItem=>{
              const assItem = {
                    supervisorCompetencyOpinionID: assessmentItem.supervisorCompetencyOpinionID || assessmentItem.userCompetencyOpinionID,
                    competencyInformationID: assessmentItem.competencyInformationID,
                    registerID: user.registerID
                };
               const index = copySupervisorAssessment.findIndex(item=> item.competencyInformationID === assItem.competencyInformationID);
                if (index === -1){
                    copySupervisorAssessment.push(assItem)
                }
            })
        }
        console.log(JSON.stringify(copySupervisorAssessment));
        //return false;
        const headers = { 'Content-Type': 'application/json' }
        axios.post(BASE_URL + '/api/competencyinformation/SetSupervisorAssesmentUpdate',
                JSON.stringify(copySupervisorAssessment),
                { headers: headers })
                .then(response=>{
                    SupervisorUpdateCount(selectedEmployeeId)
                    if (response.status === 200) {
                        var sel = document.getElementById("ddlCompetencyOpinion");
                        var _selectedText = sel.options[sel.selectedIndex].text +" [Completed]";
                        sel.options[sel.selectedIndex].text=_selectedText;

                        successNotify("Assessment Completed");

                        // primeToast.current.show({
                        //     severity: 'success',
                        //     summary: 'success',
                        //     detail: 'Assessment Completed',
                        //     life: 3000
                        // });
                    }
                }).catch(error => {
                    console.error(error)
                    errorNotify("Failed to save assessment. Please try again.")
                })

    }


    return (
        <Layout>
            <Toast ref={primeToast}/>
            <div className="card">
                <div className="card-header">
                    <div className="row">
                        <div className="col-md-3">
                            <select id="ddlCompetencyOpinion" className="form-select" onChange={onEmployeeSelect}
                                    aria-label=".form-select-sm example">
                                <option value={-1}>{"Select Employee"}</option>
                                {employees.list.map((value, index) => <option key={index}
                                                                              value={value.registerID}>{value.employeeName}</option>)}
                            </select>
                        </div>
                        <div className="col-md-2">
                        {
                                user.isLocked === true ?(
                                    <h4 className="notUpdateComment" style={{fontSize:".8rem"}}>
                                    *** This Quarter Already Locked..!
                                  </h4>
                                ):
                                (
                            <button onClick={saveAssessment} className="btn btn-primary"><i
                                className="bi bi-check-lg"/> Save
                            </button>
                            )
                        }
                        </div>
                        <div className="col-md-3" style={{textAlign: 'right','fontsize': '.85rem'}}>
                            {supervisorUpdateCount.length === 0 ? "" :
                                <b>You have Completed {supervisorUpdateCount[0].totalComplete} out
                                    of {supervisorUpdateCount[0].totalCount}</b>
                            }
                        </div>
                        <div className="col-md-4" style={{textAlign: 'right','fontsize': '.85rem'}}>
                            <b>Quarter:</b> {user.quarterName}/{new Date().getFullYear()}
                        </div>

                    </div>

                </div>

                <div className="card-body">
                    {employeeAssessment.list.length !== 0 ?
                        <EmpInfoCard empName={employeeAssessment.list[0].employeeName}
                                     department={employeeAssessment.list[0].department}
                                     designation={employeeAssessment.list[0].designation}
                                     email={employeeAssessment.list[0].email}/>
                        : (<div className="p-5"><h3>Supervisor <b>Core Competency</b> Area</h3></div>)}

                    {employeeAssessment.isLoading ? <ProgressSpinner style={{width: 40, height: 40}}/> : ""}
                    {employeeAssessment.list.length !== 0 ? <div className="row">
                        {employeeAssessment.list.map((value, index) => <div key={index} className="col-md-4 mb-2">
                            <CompOpinionCard
                                assessmentItem={
                                    {
                                        assestmentName: value.competencyName,
                                        employeeCode: value.employeeCode,
                                        email: value.email,
                                        opinionName: value.opinionName,
                                        competencyInformationID: value.competencyInformationID,
                                        comId: value.competencyID,
                                        selectedEmployeeId: selectedEmployeeId,
                                        supervisorCompetencyOpinionID: value.supervisorCompetencyOpinionID,
                                        userCompetencyOpinionID:value.userCompetencyOpinionID
                                    }
                                }
                                optionList={optionList}
                                onSupervisorOpinionChange={onSupervisorOpinionChange}/>
                        </div>)}

                        <div className="col-md-12">

                            {/* <div className="row">
                                <div className="col-md-2 mt-2">
                                    <button onClick={saveAssessment} className="btn btn-primary">Save</button>
                                </div>
                                <div className="col-md-6 mt-2">
                                    <b>Total supervisor Competency
                                        Complete {supervisorUpdateCount.length === 0 ? <>Loading..</> : supervisorUpdateCount[0].totalComplete} out
                                        of {supervisorUpdateCount.length === 0 ? <>Loading..</> : supervisorUpdateCount[0].totalCount}</b>
                                </div>
                            </div> */}

                        </div>


                    </div> : ""}


                </div>

            </div>
        </Layout>
    )
}

export default SupervisorCompOpinion